import React, { Component } from "react";
import { Route } from "react-router-dom";
import AdminDashboard from "./AdminDashboard";
import AdminMessagePatterns from "./AdminMessagePatterns";

export default class RestaurantsList extends Component {
  parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  onMessagePatterns() {
    this.props.history.push(this.props.match.path + "/MessagePatterns");
  }

  render() {
    return (
      <div>
        <Route
          exact
          path={this.props.match.path}
          render={(props) => (
            <AdminDashboard
              {...props}
              onMessagePatterns={this.onMessagePatterns.bind(this)}
            />
          )}
        />
        <Route
          path={`${this.props.match.path}/MessagePatterns`}
          render={(props) => <AdminMessagePatterns {...props} />}
        />
      </div>
    );
  }
}
